import Header from "./header";
import Footer from "./footer";
import { Outlet } from "react-router-dom";
import FooterCta from "./footerCta";
import Slider from "./slider";

function Layout() {
  return (
    <div>
      <Slider />
      <Header />
      <Outlet />
      <FooterCta />
      <Footer />
    </div>
  );
}

export default Layout;
